<template>
    <div class="hero-non-logged -wrap" v-if="!isLoggedIn">
        <TotemIntro :type="$totemLang === 'se' ? 'image' : 'video'" v-on:on-play-video="openVideoModal()">
            <template #title>
                <span v-html="$t('Hero.non_logged_title')"></span>
            </template>
            <template #description>
                <span v-html="$t('Hero.non_logged_description')"></span>
            </template>
            <template #buttons>
                <TotemRouterLink color="hero" :to="{ name:'login' }" :label="$t('Hero.log_in')" />
                <TotemRouterLink color="hero transparent" :to="trialFormRoute" :label="$t('Hero.try_for_free')" />
            </template>
            <template #image>
                <div class="intro__image-box">
                    <img :src="require('@/assets/images/hero/hero-image-non-logged' + '-' + $totemLang +'.png')" alt="" class="intro__image"/>
                </div>
            </template>
            <template #video>
                <img :src="require('@/assets/images/hero/video-screen-non-logged-' + $totemLang + '.png')" alt="" class="intro__video-thumbnail" @click="openVideoModal"/>
            </template>
        </TotemIntro>
        <HeroVideoModal :videoSrc="videoSrc" />
    </div>
</template>

<script>
    import { getTrialFormRoute } from '@/routes'
    import HeroVideoModal from '@/components/landingpage/hero/HeroVideoModal'
    import { mapGetters } from 'vuex'

    export default {
        name: 'hero-non-logged',
        components: {
            HeroVideoModal
        },
        data () {
            return {
                trialFormRoute: getTrialFormRoute()
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            videoSrc () {
                switch (this.$totemLang) {
                case 'fi':
                    return 'https://player.vimeo.com/video/897131713'
                case 'se':
                    return ''
                case 'no':
                    return 'https://player.vimeo.com/video/897131267'
                }
            }
        },
        methods: {
            goTo (params) {
                this.$router.push(params)
            },
            openVideoModal () {
                this.$modal.show('hero-video-modal')
            }
        }
    }
</script>

<style lang="scss">
    .hero-non-logged {
        &.-wrap {
            [class*="mobile"] & {
                padding: 30px 20px;
            }
        }
    }
</style>
